<template>
    <b-card>
        <app-collapse type="margin">
            <app-collapse-item title="Advance Search">
                <b-row>
                    <b-col md="4">
                        <b-form-group>
                            <label class="text-sm">Company</label>
                            <v-select
                                name="company_id"
                                :reduce="(company_id) => company_id.value"
                                multiple
                                :closeOnSelect="false"
                                :options="companyOptions"
                                @input="
                                    getUnitsByCompanyID($event, 'companyFilter')
                                "
                                placeholder="Select Company"
                            />
                        </b-form-group>
                    </b-col>

                    <b-col md="4">
                        <b-form-group>
                            <label class="text-sm">Unit</label>
                            <v-select
                                name="unit_id"
                                :reduce="(unit_id) => unit_id.value"
                                multiple
                                :closeOnSelect="false"
                                :options="sorted_unit_options"
                                @input="setSelect($event, 'unitFilter')"
                                placeholder="Select Unit"
                            />
                        </b-form-group>
                    </b-col>

                    <b-col md="4">
                        <b-form-group>
                            <label class="text-sm">Function</label>
                            <v-select
                                name="function_id"
                                v-model="form.function_id"
                                :reduce="(function_id) => function_id.value"
                                multiple
                                :closeOnSelect="false"
                                :options="functionOptions"
                                @input="
                                    getDepartmentsByFunctionID(
                                        $event,
                                        'functionFilter',
                                    )
                                "
                                placeholder="Select Function"
                            />
                        </b-form-group>
                    </b-col>
                </b-row>

                <b-row>
                    <b-col md="4">
                        <b-form-group>
                            <label class="text-sm">Department</label>
                            <v-select
                                name="department_id"
                                :reduce="(department_id) => department_id.value"
                                multiple
                                :closeOnSelect="false"
                                :options="sorted_department_options"
                                @input="
                                    getSectionsByDepartmentID(
                                        $event,
                                        'departmentFilter',
                                    )
                                "
                                placeholder="Select Department"
                            />
                        </b-form-group>
                    </b-col>

                    <b-col md="4">
                        <b-form-group>
                            <label class="text-sm">Section</label>
                            <v-select
                                name="job_location_id"
                                :reduce="(section_id) => section_id.value"
                                multiple
                                :closeOnSelect="false"
                                :options="sorted_section_options"
                                @input="setSelect($event, 'sectionFilter')"
                                placeholder="Select Section"
                            />
                        </b-form-group>
                    </b-col>

                    <b-col md="4">
                        <b-form-group>
                            <label class="text-sm">Designation</label>
                            <v-select
                                name="designation_id"
                                :reduce="
                                    (designation_id) => designation_id.value
                                "
                                multiple
                                :closeOnSelect="false"
                                :options="designationOptions"
                                @input="setSelect($event, 'designationFilter')"
                                placeholder="Select Designation"
                            />
                        </b-form-group>
                    </b-col>
                </b-row>

                <b-row>
                    <b-col md="4">
                        <b-form-group>
                            <label class="text-sm">Rank</label>
                            <v-select
                                name="rank_id"
                                :reduce="(rank_id) => rank_id.value"
                                multiple
                                :closeOnSelect="false"
                                :options="rankOptions"
                                @input="setSelect($event, 'rankFilter')"
                                placeholder="Select Rank"
                            />
                        </b-form-group>
                    </b-col>

                    <b-col md="4">
                        <b-form-group>
                            <label class="text-sm">Job Location</label>
                            <v-select
                                name="job_location_id"
                                :reduce="
                                    (job_location_id) => job_location_id.value
                                "
                                multiple
                                :closeOnSelect="false"
                                :options="joblocationOptions"
                                @input="setSelect($event, 'locationFilter')"
                                placeholder="Select Job Location"
                            />
                        </b-form-group>
                    </b-col>

                    <b-col md="4">
                        <b-form-group>
                            <label class="text-sm">Placement District</label>
                            <v-select
                                name="district_id"
                                :reduce="(district_id) => district_id.value"
                                multiple
                                :closeOnSelect="false"
                                :options="districtOptions"
                                @input="
                                    getThanaByDistrictID(
                                        $event,
                                        'districtFilter',
                                    )
                                "
                                placeholder="Select District"
                            />
                        </b-form-group>
                    </b-col>
                </b-row>

                <b-row>
                    <b-col md="4">
                        <b-form-group>
                            <label class="text-sm">Placement Thana</label>
                            <v-select
                                name="subdistrict_id"
                                :reduce="
                                    (subdistrict_id) => subdistrict_id.value
                                "
                                multiple
                                :closeOnSelect="false"
                                :options="sorted_thana_options"
                                @input="setSelect($event, 'thanaFilter')"
                                placeholder="Select Thana"
                            />
                        </b-form-group>
                    </b-col>

                    <b-col md="4">
                        <b-form-group>
                            <label class="text-sm">Status</label>
                            <v-select
                                name="status"
                                :reduce="(status) => status.value"
                                multiple
                                :closeOnSelect="false"
                                :options="sorted_status_options"
                                @input="setSelect($event, 'statusFilter')"
                                placeholder="Select Status"
                            />
                        </b-form-group>
                    </b-col>
                </b-row>
            </app-collapse-item>
        </app-collapse>
    </b-card>
</template>

<script>
import {
    BCard,
    BCardHeader,
    BCardBody,
    BRow,
    BCol,
    BFormDatepicker,
    BFormInput,
    BButton,
    BFormGroup,
} from "bootstrap-vue";
import vSelect from "vue-select";
import AppCollapse from "@core/components/app-collapse/AppCollapse.vue";
import AppCollapseItem from "@core/components/app-collapse/AppCollapseItem.vue";
import { ref } from "@vue/composition-api";

// import getUnitList from "../composables/settings/getUnitList"
// import getDepartmentList from "../composables/settings/getDepartmentList"
// import getSectionList from "../composables/settings/getSectionList"
// import getSubdistrictList from "../composables/settings/getSubdistrictList"

export default {
    components: {
        BRow,
        BCol,
        BFormDatepicker,
        BFormInput,
        BButton,
        BCard,
        BCardHeader,
        BCardBody,
        BFormGroup,
        vSelect,
        AppCollapse,
        AppCollapseItem,
    },

    data() {
        return {
            searchQuery: "",
            defaultSelected: {
                label: "Active",
                value: "active",
            },

            form: {
                company_id: "",
                unit_id: [],
                function_id: "",
                department_id: [],
                section_id: [],
                designation_id: "",
                rank_id: "",
                job_location_id: "",
                district_id: "",
                subdistrict_id: [],
            },
        };
    },
    setup() {
        // const {
        //     unit_list
        // } = getUnitList()
        // const {
        //     department_list
        // } = getDepartmentList()
        // const {
        //     section_list
        // } = getSectionList()
        // const {
        //     subdistrict_list
        // } = getSubdistrictList()

        const sorted_unit_options = ref([]);
        const sorted_department_options = ref([]);
        const sorted_section_options = ref([]);
        const sorted_thana_options = ref([]);
        const sorted_status_options = ref([
            { label: "Draft", value: "Draft" },
            { label: "New", value: "New" },
            { label: "Active", value: "Active" },
            { label: "Approved", value: "Approved" },
            { label: "Expired", value: "Expired" },
            { label: "Reject", value: "Reject" },
            { label: "Hired", value: "Hired" },
            { label: "Completed", value: "Completed" },
        ]);
        //const sorted_department_options = ref([])

        return {
            unit_list,
            department_list,
            section_list,
            subdistrict_list,
            sorted_unit_options,
            sorted_department_options,
            sorted_section_options,
            sorted_thana_options,
            sorted_status_options,
        };
    },
    watch: {},
    methods: {
        setSelect(val, filterName) {
            let value = val.join();
            this.$emit("update:" + filterName, value);
        },
        searchSubmitBtn() {
            this.$emit("eventSearchSubmitBtn", this.form);
        },
        getUnitsByCompanyID(id, filterName) {
            let companyIDs = id.join(); //implode as comma

            this.form.unit_id = [];
            this.sorted_unit_options = [];
            if (companyIDs != "" && companyIDs) {
                this.sorted_unit_options = this.unit_list.filter((item) => {
                    return companyIDs.includes(item.company_id);
                });
            }
            this.$emit("update:" + filterName, companyIDs);
        },
        getDepartmentsByFunctionID(id, filterName) {
            let functionIDs = id.join(); //implode as comma

            this.form.department_id = [];
            this.sorted_department_options = [];
            if (functionIDs != "" && functionIDs) {
                this.sorted_department_options = this.department_list.filter(
                    (item) => {
                        return functionIDs.includes(item.function_id);
                    },
                );
            }
            this.$emit("update:" + filterName, functionIDs);
        },
        getSectionsByDepartmentID(id, filterName) {
            let departmentIDs = id.join(); //implode as comma

            this.form.section_id = [];
            this.sorted_section_options = [];
            if (departmentIDs != "" && departmentIDs) {
                this.sorted_section_options = this.section_list.filter(
                    (item) => {
                        return departmentIDs.includes(item.department_id);
                    },
                );
            }
            this.$emit("update:" + filterName, departmentIDs);
        },
        getThanaByDistrictID(id, filterName) {
            let districtIDs = id.join(); //implode as comma

            this.form.subdistrict_id = [];
            this.sorted_thana_options = [];
            if (districtIDs != "" && districtIDs) {
                this.sorted_thana_options = this.subdistrict_list.filter(
                    (item) => {
                        return districtIDs.includes(item.district_id);
                    },
                );
            }
            this.$emit("update:" + filterName, districtIDs);
        },
    },
    props: {
        companyFilter: {
            type: [String, null],
            default: null,
        },
        unitFilter: {
            type: [String, null],
            default: null,
        },
        functionFilter: {
            type: [String, null],
            default: null,
        },
        designationFilter: {
            type: [String, null],
            default: null,
        },
        rankFilter: {
            type: [String, null],
            default: null,
        },
        locationFilter: {
            type: [String, null],
            default: null,
        },
        districtFilter: {
            type: [String, null],
            default: null,
        },
        thanaFilter: {
            type: [String, null],
            default: null,
        },
        statusFilter: {
            type: [String, null],
            default: null,
        },

        companyOptions: {
            type: Array,
            required: true,
        },
        functionOptions: {
            type: Array,
            required: true,
        },
        designationOptions: {
            type: Array,
            required: true,
        },
        rankOptions: {
            type: Array,
            required: true,
        },
        joblocationOptions: {
            type: Array,
            required: true,
        },
        districtOptions: {
            type: Array,
            required: true,
        },
    },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
